import React from 'react';
import { SelectOption } from 'global';
import { useFormContext } from 'react-hook-form';
import { autocompletePropsByType } from 'modules/jsonRulesCriterias/businessCriteria/constants';
import { FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { FinanceProgramForm } from '../../../../schema';
import { AutocompleteField, ChipsInputField } from '../../../../../../components/form';

interface Props {
  index: number;
  type: FACT_NAMES_STRING;
  dealerOptions?: SelectOption[];
}

export const StringFieldsByRule = ({ index, type, dealerOptions = [] }: Props) => {
  const { control } = useFormContext<FinanceProgramForm>();

  // Handle DEALERS fact type with dynamic dealer options
  if (type === FACT_NAMES_STRING.DEALERS) {
    return (
      <AutocompleteField<SelectOption, true, FinanceProgramForm>
        multiple
        size="small"
        control={control}
        options={dealerOptions}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        name={`program.first.criteria.conditions.${index}.string.value`}
        textFieldProps={{
          required: true,
          label: 'Select Dealers',
        }}
      />
    );
  }

  return (
    <>
      {autocompletePropsByType?.[type as FACT_NAMES_STRING] ? (
        <AutocompleteField<SelectOption, true, FinanceProgramForm>
          multiple
          size="small"
          control={control}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          name={`program.first.criteria.conditions.${index}.string.value`}
          {...autocompletePropsByType[type as FACT_NAMES_STRING]!}
        />
      ) : (
        <ChipsInputField name={`program.first.criteria.conditions.${index}.string.value`} control={control} />
      )}
    </>
  );
};
